module.exports = __webpack_public_path__ + "static/StudioPro-Regular-b561062ae9197e0dd3a8e5e8a333cdcb.woff";